import type { PageCard } from '@/play/pageTypes'
import { CanalCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'canal',
  number: 4,
  title: 'Canal',
  question: 'Does a fixed water level make digging meaningful: cut below it and the water comes in?',
  status: 'open',
  accent: '#7fc8d3',
  CardArt: CanalCardArt,
}
